import React from 'react';
import { useUser } from '../../contexts/userContext';
import { useWhatsappZapi } from '../../contexts/whatsappZapiContext';
import WhatsappZapiModal from './WhatsappZapiModal';
import './WhatsappZapi.css';

function WhatsappZapiFloatingButton({ theme = 'light' }) {
  const { user } = useUser();
  const { unreadCount, openWhatsappZapi, isWhatsappZapiOpen, isMetaChannelOwner } = useWhatsappZapi();
  // Botao flutuante so para super admin e responsaveis por numero oficial.
  // A janela continua abrindo quando outras telas (ex.: card) chamam openWhatsappZapi.
  const canSeeButton = Number(user?.access_level) === 8 || isMetaChannelOwner;

  return (
    <>
      {canSeeButton && (
        <button
          type="button"
          className={`zapi-whatsapp-floating-button ${unreadCount > 0 ? 'zapi-whatsapp-floating-button--unread' : ''}`}
          onClick={() => openWhatsappZapi()}
          title="Syncs Messenger"
          aria-label="Abrir Syncs Messenger"
        >
          <img src="/syncs-logo-meta-v1.png" alt="" aria-hidden="true" />
          {unreadCount > 0 && (
            <span className="zapi-whatsapp-floating-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
          )}
        </button>
      )}
      {isWhatsappZapiOpen && <WhatsappZapiModal theme={theme} />}
    </>
  );
}

export default WhatsappZapiFloatingButton;
